// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","479":"ed632de7","523":"1ffe7e97","524":"437bed6f","744":"a617acce","933":"be1d10a0"}[chunkId] + ".chunk.js";
};